export const yesNoOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
]

export const sponsorOptions = [
    { label: 'Yes', value: 'sponsored' },
    { label: 'No', value: 'unsponsored' },
]

export const productTagOptions = [
    { label: 'Best Seller', value: 'Best Seller' },
    { label: 'All time Favorite', value: 'All Time Favorite' },
    { label: 'Recommended', value: 'Recommended' },
    { label: 'New Comer', value: 'New Comer' },
]

export const featureOptions = [
    { label: 'Machine', value: 'Machine' },
    { label: 'Grinder', value: 'Grinder' },
    // { label: 'Beans', value: 'beans' },
    { label: 'Other', value: 'other' },
]

export const taxTypeOptions = [
    { label: 'Including', value: 0 },
    { label: 'Exluding', value: 1 },
]

export const subTypeOptions = [
    { label: 'Product', value: 0 },
    { label: 'Addon', value: 1 },
]

export const couponTypeOptions = [
    { label: 'Percentage', value: 'PERCENTAGE' },
    { label: 'Fixed Amount', value: 'FIXED' },
]

export const filterOptions = [
    { label: 'All', value: '' },
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
]

export const productOptions = [
    { label: 'Product', value: false },
    { label: 'Addon', value: true },
]

export const assetOptions = [
    { label: 'Equity', value: 'Equity' },
    { label: 'Liquid', value: 'Liquid' },
    { label: 'Debt', value: 'Debt' },
]

export const typeOptions = [
    { label: 'min', value: 'min' },
    { label: 'max', value: 'max' },
]
export const operatorOptions = [
    { label: '>', value: '>' },
    { label: '<', value: '<' },
    { label: '=', value: '=' },
]



export const lengthOption = [
    {
        id: 10,
        label: 10,
    },
    {
        id: 25,
        label: 25,
    },
    {
        id: 50,
        label: 50,
    },
    {
        id: 100,
        label: 100,
    },
]
export const daysOptions = [
    {
        label: '1 Month',
        value: 30
    },
    {
        label: '3 Month',
        value: 90
    },
    {
        label: '1 Year',
        value: 365
    },


]
export const moduleList = [
    { key: 'log entry', name: 'log-entry' },
    { key: 'content type', name: 'content-type' },
    { key: 'session', name: 'session' },
    { key: 'Token', name: 'Token' },
    { key: 'user subscription', name: 'user-subscription' },
    { key: 'users otp log', name: 'users-otp-log' },
    { key: 'user profile', name: 'user-profile' },
    { key: 'user mfa devices', name: 'user-mfa-devices' },
    { key: 'user auth provider', name: 'user-auth-provider' },
    { key: 'user', name: 'users' },
    { key: 'group', name: 'roles' },
    { key: 'permission', name: 'assign-permissions' },
    { key: 'Meripehchaan SSO Session', name: 'Meripehchaan-SSO-Session' },
    { key: 'Meripehchaan Audit Log', name: 'Meripehchaan-Audit-Log' },
    { key: 'Meripehchaan Access Token', name: 'Meripehchaan-Access-Token' },
    { key: 'Meripehchaan User Mapping', name: 'Meripehchaan-User-Mapping' },
    { key: 'notification settings', name: 'notification-settings' },
    { key: 'privacy choices', name: 'privacy-choices' },
    { key: 'user preferences', name: 'user-preferences' },

]
